import { createTheme } from "@mui/material/styles";

export const pinTrackingTheme = createTheme({
  palette: {
    primary: {
      main: "#99cc00",
    },
    secondary: {
      main: "#003366",
    },
    warning: {
      main: "#e4a600"
    }
  },
});
